import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, Check } from "lucide-react";
import { Button } from "@/components/ui/button";
import SEO from "@/components/site/SEO";
import { SERVICES, COMPANY } from "@/lib/constants";

export default function Services() {
  return (
    <div>
      <SEO
        title="Concrete Services in Watertown, WI | CG Concrete LLC"
        description="Driveways, patios, sidewalks, garage & basement floors, stamped and colored concrete in Watertown, WI. Licensed & insured. Free estimates."
      />
      <section className="bg-secondary text-white grain-texture">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 lg:py-28">
          <span className="text-primary font-bold text-sm tracking-widest">OUR SERVICES</span>
          <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-extrabold mt-3 max-w-3xl">Concrete Done Right, Start to Finish</h1>
          <p className="text-white/70 mt-5 text-lg max-w-2xl">From residential driveways to decorative patios, we handle the full scope — prep, pour, and finish — with quality that lasts.</p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 space-y-20">
        {SERVICES.map((s, i) => (
          <motion.div
            key={s.slug}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.6 }}
            className={`grid lg:grid-cols-2 gap-10 items-center ${i % 2 === 1 ? "lg:[direction:rtl]" : ""}`}
            data-testid={`service-block-${s.slug}`}
          >
            <div className="[direction:ltr]">
              <img src={s.image} alt={s.title} className="w-full aspect-[4/3] object-cover border border-border" />
            </div>
            <div className="[direction:ltr]">
              <h2 className="font-heading text-3xl lg:text-4xl font-extrabold">{s.title}</h2>
              <p className="text-muted-foreground mt-4 leading-relaxed text-lg">{s.description}</p>
              <ul className="mt-6 grid sm:grid-cols-2 gap-x-6 gap-y-3">
                {s.features.map((f) => (
                  <li key={f} className="flex items-start gap-2 text-sm font-medium"><Check className="h-4 w-4 text-primary mt-0.5 shrink-0" /> {f}</li>
                ))}
              </ul>
              <Button asChild className="mt-7 bg-primary hover:bg-primary/90 rounded-sm font-bold h-12 px-6" data-testid={`service-detail-btn-${s.slug}`}>
                <Link to={`/services/${s.slug}`}>Details & FAQs <ArrowRight className="ml-2 h-4 w-4" /></Link>
              </Button>
            </div>
          </motion.div>
        ))}
      </section>

      <section className="bg-card border-t border-border">
        <div className="max-w-3xl mx-auto px-4 py-16 text-center">
          <h2 className="font-heading text-3xl font-extrabold">Not sure what you need?</h2>
          <p className="text-muted-foreground mt-3">Call {COMPANY.owner} at {COMPANY.phone} or request a free quote and we'll help you figure it out.</p>
          <Button asChild className="mt-6 bg-secondary hover:bg-secondary/90 rounded-sm font-bold h-12 px-8">
            <Link to="/contact">Request Free Quote</Link>
          </Button>
        </div>
      </section>
    </div>
  );
}
